import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ui-toggle',
  standalone: true,
  imports: [],
  template: `
    <label class="flex items-center gap-2 cursor-pointer select-none" [class.opacity-50]="disabled" [class.pointer-events-none]="disabled">
      <input
        type="checkbox"
        class="toggle"
        [class]="toggleClass"
        [checked]="checked"
        [disabled]="disabled"
        (change)="onChange($event)"
      />
      @if (label) {
        <span class="label-text text-sm">{{ label }}</span>
      }
      <ng-content></ng-content>
    </label>
  `,
})
export class UiToggleComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() label = '';
  @Input() color: 'primary' | 'success' | 'warning' | 'error' | 'info' = 'primary';

  @Output() checkedChange = new EventEmitter<boolean>();

  get toggleClass(): string {
    return `toggle toggle-${this.color}`;
  }

  onChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checkedChange.emit(target.checked);
  }
}

